import useMutationCompanyCreateUpdate from "./company-use-mutation-create-update";
import useMutationCompanyDelete from "./company-use-mutation-delete";

export const companyUseMutation = {
  createUpdate: useMutationCompanyCreateUpdate,
  delete: useMutationCompanyDelete,
};
